import React, { FC } from 'react';
import { Badge, BadgeType } from '@components/atoms/Badge';
import { useTranslation } from 'react-i18next';

interface StoreStateBadgeProps {
    state: string;
}

export const StoreStateBadge: FC<StoreStateBadgeProps> = ({ state }) => {
    const { t } = useTranslation();

    const translations = {
        activeLabel: t('store-state.active'),
        inactiveLabel: t('store-state.inactive'),
        pendingLabel: t('store-state.pending'),
        closedLabel: t('store-state.closed'),
    };

    switch (state) {
        case 'active':
            return <Badge label={translations.activeLabel} type={BadgeType.success} icon="fa-light fa-check" />;
        case 'inactive':
            return <Badge label={translations.inactiveLabel} type={BadgeType.danger} icon="fa-light fa-xmark" />;
        case 'pending':
            return <Badge label={translations.pendingLabel} type={BadgeType.warning} icon="fa-light fa-gear" />;
        case 'closed':
            return <Badge label={translations.closedLabel} type={BadgeType.danger} icon="fa-light fa-xmark" />;
        default:
            <></>;
    }
};
